export enum CrmAppEnum {
  EXPORT = 'EXPORT',
  ENRICH = 'ENRICH',
  ENRICH_BCE = 'ENRICH_BCE',
}
